const authManager = {

  setcorporateAdminAccessToken: (accessToken) => {
    try {
      localStorage.setItem("accesscorporateAdminToken", accessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getcorporateAdminAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("accesscorporateAdminToken");
  },

  deletecorporateAdminAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("accesscorporateAdminToken");
    }
  },

  hascorporateAdminAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accesscorporateAdminToken");
  },
};

export default authManager;
